<div class="row">
  @for (product of productsSignal(); track product._id) {
  <div class="col-12 col-sm-12 col-md-6 col-lg-4">
    @if (product?._source) {
    <base-product-list-card [productInput]="product._source"></base-product-list-card>
    }
  </div>
  }
</div>
